import React from 'react'
import { Title } from '../../atoms'

export const PriceBox = ({ topText, bottomText, className = "priceBox", textSize="" }) => {
  return (
    <div className={className}>
      <Title text={topText} className="topText" />
      <Title text={bottomText} className={["bottomText text",textSize].join(' ') } />
    </div>
  )
}
